export default __webpack_public_path__ + "static/media/rental-equipment.dbda268f.jpg";